/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Event creation request
 * @export
 * @interface CreateCaseEventRequest
 */
export interface CreateCaseEventRequest {
    /**
     * Type of the event
     * @type {string}
     * @memberof CreateCaseEventRequest
     */
    eventType: CreateCaseEventRequestEventTypeEnum;
    /**
     * Title of the event
     * @type {string}
     * @memberof CreateCaseEventRequest
     */
    title?: string;
    /**
     * Description of the event
     * @type {string}
     * @memberof CreateCaseEventRequest
     */
    description?: string;
    /**
     * Timestamp when the event occurred
     * @type {Date}
     * @memberof CreateCaseEventRequest
     */
    timestamp?: Date;
    /**
     * Severity level of the event
     * @type {string}
     * @memberof CreateCaseEventRequest
     */
    severity?: CreateCaseEventRequestSeverityEnum;
    /**
     * Source of the event
     * @type {string}
     * @memberof CreateCaseEventRequest
     */
    source?: string;
    /**
     * Additional metadata for the event
     * @type {{ [key: string]: any; }}
     * @memberof CreateCaseEventRequest
     */
    metadata?: { [key: string]: any; };
    /**
     * Creator of the event (if not provided, uses authenticated user)
     * @type {string}
     * @memberof CreateCaseEventRequest
     */
    createdBy?: string;
    /**
     * Creation timestamp of the event (if not provided, uses current time)
     * @type {Date}
     * @memberof CreateCaseEventRequest
     */
    createdAt?: Date;
}


/**
 * @export
 */
export const CreateCaseEventRequestEventTypeEnum = {
    Note: 'note',
    CaseCreated: 'case_created',
    CaseAssigned: 'case_assigned',
    CaseEscalated: 'case_escalated',
    CaseClosed: 'case_closed',
    CaseReopened: 'case_reopened',
    CaseFeedback: 'case_feedback',
    CaseResolved: 'case_resolved',
    StatusChange: 'status_change',
    Feedback: 'feedback',
    CaseUpdated: 'case_updated',
    CaseOwnerChanged: 'case_owner_changed',
    CaseSeverityChanged: 'case_severity_changed',
    CaseEscalationCleared: 'case_escalation_cleared',
    Comment: 'comment',
    Evidence: 'EVIDENCE',
    Investigation: 'INVESTIGATION',
    Analysis: 'ANALYSIS',
    Response: 'RESPONSE'
} as const;
export type CreateCaseEventRequestEventTypeEnum = typeof CreateCaseEventRequestEventTypeEnum[keyof typeof CreateCaseEventRequestEventTypeEnum];

/**
 * @export
 */
export const CreateCaseEventRequestSeverityEnum = {
    Critical: 'CRITICAL',
    High: 'HIGH',
    Medium: 'MEDIUM',
    Low: 'LOW',
    Info: 'INFO'
} as const;
export type CreateCaseEventRequestSeverityEnum = typeof CreateCaseEventRequestSeverityEnum[keyof typeof CreateCaseEventRequestSeverityEnum];


/**
 * Check if a given object implements the CreateCaseEventRequest interface.
 */
export function instanceOfCreateCaseEventRequest(value: object): value is CreateCaseEventRequest {
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    return true;
}

export function CreateCaseEventRequestFromJSON(json: any): CreateCaseEventRequest {
    return CreateCaseEventRequestFromJSONTyped(json, false);
}

export function CreateCaseEventRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCaseEventRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'eventType': json['eventType'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'timestamp': json['timestamp'] == null ? undefined : (new Date(json['timestamp'])),
        'severity': json['severity'] == null ? undefined : json['severity'],
        'source': json['source'] == null ? undefined : json['source'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'createdBy': json['created_by'] == null ? undefined : json['created_by'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
    };
}

export function CreateCaseEventRequestToJSON(json: any): CreateCaseEventRequest {
    return CreateCaseEventRequestToJSONTyped(json, false);
}

export function CreateCaseEventRequestToJSONTyped(value?: CreateCaseEventRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eventType': value['eventType'],
        'title': value['title'],
        'description': value['description'],
        'timestamp': value['timestamp'] == null ? undefined : ((value['timestamp']).toISOString()),
        'severity': value['severity'],
        'source': value['source'],
        'metadata': value['metadata'],
        'created_by': value['createdBy'],
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
    };
}

